import {useEffect, useState} from "react";
import {getExchangeCode, getToken, saveExchangeCode} from "./Storage";
import {getUserInfoThunk, refreshTokenThunk, selectUserInfo} from "../redux/slices/appSlice";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "../redux/store";

export const useLogin = () => {
    const dispatch: AppDispatch = useDispatch();
    const selUserInfo = useSelector(selectUserInfo);

    const [isLogin, setIsLogin] = useState<boolean | undefined>(undefined);

    useEffect(() => {
        if (selUserInfo) {
            setIsLogin(false);
        }
    }, [selUserInfo]);

    useEffect(() => {
        if (selUserInfo) {
            setIsLogin(false)
        } else {
            (async () => {
                const token = getToken();
                if (!token) {
                    let exchangeCode = getExchangeCode();
                    if (!exchangeCode) {
                        const searchParams = new URLSearchParams(window.location.search);
                        if (searchParams.get("code")) {
                            exchangeCode = searchParams.get("code") as string;
                            saveExchangeCode(exchangeCode);
                        }
                    }
                    if (exchangeCode) {
                        const {payload} = await dispatch(refreshTokenThunk(exchangeCode));
                        if (payload?.code !== 0) {
                            return setIsLogin(true);
                        }
                    } else {
                        return setIsLogin(true);
                    } //
                } //
                const {payload} = await dispatch(getUserInfoThunk(getToken() as string));
                if (!payload || payload?.code !== 0) {
                    setIsLogin(true);
                } else {
                    setIsLogin(false);
                }
            })();
        }
    }, [dispatch]);

    return [isLogin];
}
